import type { IconData } from '@stacksjs/iconify-core'

export const pe1x1: IconData = {
  "body": "<path fill=\"#D91023\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M170.7 0h170.6v512H170.7z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pe1x1
